/**
 * AUTO-GENERATED — DO NOT EDIT
 *
 * Generated by tools/gen-sqlite-from-db-schema.ts
 * To regenerate, run: pnpm powersync:schema:generate
 */

import { integer, real, sqliteTable, text } from 'drizzle-orm/sqlite-core';

export const formTemplateMappings = sqliteTable('form_template_mappings', {
  id: text('id').primaryKey().notNull(),
  form_definition_id: text('form_definition_id'),
  page_id: text('page_id'),
  field_key: text('field_key'),
  field_type: text('field_type'),
  x_pct: real('x_pct'),
  y_pct: real('y_pct'),
  w_pct: real('w_pct'),
  h_pct: real('h_pct'),
  config: text('config'),
  sort_order: integer('sort_order'),
  created_at: text('created_at'),
  updated_at: text('updated_at'),
});
